export class GetSpareStockReqDto {
    warehouse: number;
    stockZone: string;
    location: string;
    locationDescription: string;
    pch: string;
    procurementGroup: string;
    productGroup: string;
    orderType: string
    statusProposal: string;
    allStockType: string
    age: number;
    constructor(
        warehouse?: number,
        stockZone?: string,
        location?: string,
        locationDescription?: string,
        pch?: string,
        procurementGroup?: string,
        productGroup?: string,
        orderType?: string,
        statusProposal?: string,
        allStockType?: string,
        age?: number,
    ) {
        this.warehouse = warehouse
        this.stockZone = stockZone
        this.location = location
        this.locationDescription = locationDescription
        this.pch = pch
        this.procurementGroup = procurementGroup
        this.productGroup = productGroup
        this.orderType = orderType
        this.statusProposal = statusProposal
        this.allStockType = allStockType
        this.age = age
    }
}